<template>
  <div :class="model.background">
    <div class="inno-carousel container mx-auto mb-12 max-w-screen-xl overflow-hidden py-16 pb-20">
      <InnoCarousel
        v-if="products.length"
        :title="model.title"
        :subtitle="model.subtitle"
        :slides="products"
        :options="relatedProductsCarouselOptions"
        :pagination="isMobile"
        :navigation="!isMobile && products.length > 3"
      >
        <template #slide="{ slide }">
          <InnoCarouselProductCard :product="slide" class="mb-6" />
        </template>
      </InnoCarousel>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { onMounted } from "vue";
import { useProducts, InnoCarouselProductCard } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";
import type { PropType } from "vue";

const props = defineProps({
  relatedProducts: {
    type: Array as PropType<Product[]>,
    required: true,
  },

  model: {
    type: Object,
    required: true,
  },
});

type ProductSkuType = {
  productSku: string;
};

const { products, fetchProducts } = useProducts();
const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg");

const relatedProductsCarouselOptions: ICarouselOptions = {
  spaceBetween: 10,
  slidesPerView: 1,
  allowTouchMove: false,
  breakpoints: {
    1024: {
      slidesPerView: "auto",
      spaceBetween: 10,
    },
    1280: {
      slidesPerView: "auto",
      spaceBetween: 30,
    },
  },
};

let productSkus: string[] = [];

if (props.model.skus) {
  productSkus = props.model.skus.map(({ productSku }: ProductSkuType) => productSku);
}

onMounted(async () => {
  if (productSkus) {
    await fetchProducts({ filter: `"SKU":${productSkus}` });
  } else {
    await fetchProducts({
      itemsPerPage: 8,
      keyword: props.model.query,
    });
  }
});
</script>
